import { render } from "./HeroiconsOutlineDeviceMobile.vue?vue&type=template&id=64cb3f36"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDeviceMobile.vue"]])

export default __exports__